import { render, staticRenderFns } from "./Effect.vue?vue&type=template&id=79166702"
import script from "./Effect.vue?vue&type=script&lang=js"
export * from "./Effect.vue?vue&type=script&lang=js"
import style0 from "./Effect.vue?vue&type=style&index=0&id=79166702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports